import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Box } from 'shared/mui/Box';
import { Button } from 'shared/mui/Buttons';
import { CardActionsButtons, CardHeader } from 'shared/mui/Card';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';
import { Dialog } from 'shared/mui/Dialogs';
import { Divider } from 'shared/mui/Divider/Divider';
import { CloseIconButton } from 'shared/mui/IconButtons';
import { Typography } from 'shared/mui/Typography';

import { LiStyled, OlStyled } from './OrdersListReferenceDialog.styled';

type Props = {
  open: boolean;
  onClose: VoidFunction;
};

export const OrdersListReferenceDialog: React.FC<Props> = ({ open, onClose }) => {
  const translate = useTypedTranslate();

  return (
    <Dialog
      onClose={onClose}
      open={open}
      sx={{ '& .MuiDialog-paper': { overflow: 'hidden' } }}
      width="640px"
    >
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden' }}>
        <CardHeader
          appendActions={<CloseIconButton key="close-button" onClose={onClose} />}
          sx={{ height: 'auto' }}
          title={translate('app.orders.bulkResendNotificationsGuide.title')}
          titleSize="smallBold"
        />
        <CardContent sx={{ overflow: 'auto', flex: 1, minHeight: 0 }}>
          <Typography sx={{ marginBottom: '8px' }} variant="body2">
            {translate('app.orders.bulkResendNotificationsGuide.intro1')}
          </Typography>
          <Typography sx={{ marginBottom: '8px' }} variant="body2">
            {translate('app.orders.bulkResendNotificationsGuide.intro2')}
          </Typography>
          <Typography sx={{ fontWeight: 500, marginBottom: '4px' }} variant="body2">
            {translate('app.orders.bulkResendNotificationsGuide.stepsTitle')}
          </Typography>
          <OlStyled>
            <LiStyled>{translate('app.orders.bulkResendNotificationsGuide.step1')}</LiStyled>
            <LiStyled>{translate('app.orders.bulkResendNotificationsGuide.step2')}</LiStyled>
            <LiStyled>{translate('app.orders.bulkResendNotificationsGuide.step3')}</LiStyled>
          </OlStyled>
          <Typography variant="body2">
            {translate('app.orders.bulkResendNotificationsGuide.afterConfirmation')}
          </Typography>
          <Divider sx={{ marginY: '16px' }} />
          <Typography sx={{ fontWeight: 500, marginBottom: '8px' }} variant="body1">
            {translate('app.orders.bulkResendNotificationsGuide.limitTitle')}
          </Typography>
          <Typography variant="body2">
            {translate('app.orders.bulkResendNotificationsGuide.limit')}
          </Typography>
          <Divider sx={{ marginY: '16px' }} />
          <Typography sx={{ fontWeight: 500, marginBottom: '8px' }} variant="body1">
            {translate('app.orders.bulkResendNotificationsGuide.scopeTitle')}
          </Typography>
          <Typography variant="body2">
            {translate('app.orders.bulkResendNotificationsGuide.scope')}
          </Typography>
          <Divider sx={{ marginY: '16px' }} />
          <Typography sx={{ fontWeight: 500, marginBottom: '8px' }} variant="body1">
            {translate('app.orders.bulkResendNotificationsGuide.availabilityTitle')}
          </Typography>
          <Typography variant="body2">
            {translate('app.orders.bulkResendNotificationsGuide.availability')}
          </Typography>
        </CardContent>
        <CardActionsButtons
          rightActionsSlot={
            <Button
              label={translate('app.orders.bulkResendNotificationsGuide.closeButton')}
              onClick={onClose}
              variant="outlined"
            />
          }
        />
      </Box>
    </Dialog>
  );
};
